import VxCellButtons from '@/components/table/vx-table-cells/vx-cell-button/VxCellButtons'

export * from '@/components/table/vx-table-cells/vx-cell-button/consts'
export default VxCellButtons
